import React from 'react'
import "./loadspinner.css"

const LoadSpinner = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner">
      </div>
    </div>
  )
}

export default LoadSpinner
